import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import jwt_decode from "jwt-decode";
function FooterComp() {
  let navigate = useNavigate();
  let currentDate = new Date();
  var currenttime = currentDate.getTime();
  const currentYear = currentDate.getFullYear();
  const gettoken = localStorage.getItem("key");
  const token_data = jwt_decode(gettoken);
  const newToken = JSON.parse(gettoken);
  const storeToken = newToken.value;
  useEffect(() => {
    if (currenttime > token_data.exp * 1000) {
      navigate("/login");
    }
  }, []);
  return <div className="dash_footer">@ {currentYear} Hive. All rights reserved.</div>;
}

export default FooterComp;
